import { StudentWithAttendance } from "@/types/attendance";
import { Student } from "@/types/student";

export const processStudentsWithAttendance = (
  filteredStudents: Student[],
  getStudentAttendance: (studentId: string) => any[],
  selectedDate: string,
  attendanceChanges: {
    [studentId: string]:
      | "present"
      | "absent"
      | "late"
      | "absent_with_reason"
      | undefined;
  },
  selectedPeriod?: string
): {
  studentsWithAttendanceData: StudentWithAttendance[];
  hasExisting: boolean;
} => {
  let hasExisting = false;

  const studentsWithAttendanceData = filteredStudents.map((s) => {
    const studentAttendance = getStudentAttendance(s.id);
    const attendanceForDate = studentAttendance.find((record) => {
      const dateMatches = record.date === selectedDate;
      if (selectedPeriod) {
        const periodMatches = record.period === parseInt(selectedPeriod);
        console.log("Period comparison:", {
          recordPeriod: record.period,
          selectedPeriod: selectedPeriod,
          parsedPeriod: parseInt(selectedPeriod),
          matches: periodMatches,
        });
        return dateMatches && periodMatches;
      } else {
        // For daily attendance, period should be null/undefined or 1
        return dateMatches && (!record.period || record.period === 1);
      }
    });

    if (attendanceForDate) {
      hasExisting = true;
    }

    let status:
      | "present"
      | "absent"
      | "absent_with_reason"
      | "late"
      | undefined;
    if (Object.hasOwn(attendanceChanges, s.id)) {
      status = attendanceChanges[s.id];
    } else {
      status = attendanceForDate ? attendanceForDate.status : undefined;
    }

    // Convert status to isPresent for backward compatibility
    let isPresent: boolean | undefined;
    let absentWithReason: boolean | undefined;
    if (status === "present" || status === "late") {
      isPresent = true;
    } else if (status === "absent") {
      isPresent = false;
    } else if (status === "absent_with_reason") {
      isPresent = false;
      absentWithReason = true;
    } else {
      isPresent = undefined;
    }

    console.log("Processing student attendance:", {
      studentId: s.id,
      name: s.name,
      hasExistingRecord: !!attendanceForDate,
      status,
      isPresent,
      absentWithReason,
      attendanceChanges: attendanceChanges[s.id],
    });

    return {
      ...s,
      isPresent,
      absentWithReason,
      status,
      absenceDays: 0, // These will be calculated properly in Reports
      lateDays: 0,
      attendancePercentage: 0,
    };
  });

  return { studentsWithAttendanceData, hasExisting };
};

export const getStageDisplayName = (stageId: string): string => {
  const stageNames: { [key: string]: string } = {
    kindergarten: "رياض الأطفال",
    early_childhood: "الطفولة المبكرة",
    elementary: "الابتدائية",
    middle: "المتوسطة",
    high: "الثانوية",
  };
  return stageNames[stageId] || stageId;
};
